// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1m3VW","content":"styles_content__v-vFC","row":"styles_row__5rouw","footer":"styles_footer__SnRJE","phraseLength":"styles_phraseLength__10Xby"};